import { ITurnLite, ITurnLiteData } from "./turnLite.types";
import { IBusStopLite } from "../busStop";
import { ILineSet, IEarlyDriveData } from "./lineInfo.types";

export class TurnLite implements ITurnLite {
  readonly id: string;
  readonly turnNum: string;
  readonly turnName: string;
  readonly earlyDriveInfos?: IEarlyDriveData[];
  readonly beginStationDepartureTime: string;
  readonly stations: IBusStopLite[];
  readonly bookYn: boolean;
  readonly lineSets: ILineSet[];
  readonly busStops: IBusStopLite[];

  constructor(data: ITurnLiteData) {
    this.id = data.id;
    this.turnNum = data.turnNum;
    this.turnName = data.turnName;
    this.earlyDriveInfos = data.earlyDriveInfos;
    this.beginStationDepartureTime = data.beginStationDepartureTime;
    this.stations = data.stations;
    this.bookYn = data.bookYn;
    this.lineSets = data.lineSets;
    this.busStops = data.stations; // alias for compatibility
  }
}
